//core
import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";

//services
import {reportsSettingsService} from "../../../services/common/reportsSettings.service";
import {getListData} from "../../agent/agents";
import {setGeneralProgressHide, setGeneralProgressShow} from "../ui";
import {agentsService} from "../../../services/agent/agents.service";
import {setUser} from "../user";

export type reportsSettingsSliceState = {
  agentStatReport: {
    data: any | null,
    error: any | null,
    isFetching: boolean,
  }
};

const initialState: reportsSettingsSliceState = {
  agentStatReport: {
    data: null,
    error: null,
    isFetching: false,
  }
};

export const getAgentStatReportSettingsData = createAsyncThunk(
  'reportsSettings/getAgentStatReportSettingsData',
  async (payload: any, { dispatch, rejectWithValue }) => {
    dispatch(setGeneralProgressShow());
    try {
      const response = await reportsSettingsService.getAgentStatReportSettings();
      const data = await response.json();

      if (!response.ok) {
        dispatch(setGeneralProgressHide());
        return rejectWithValue(data)
      }

      dispatch(setGeneralProgressHide());

      return !!data[payload.platformCode] ? data[payload.platformCode] : {
        admin: {
          list: []
        },
        agent: {
          list: []
        },
        affiliate: {
          list: []
        }
      };
    } catch (error) {
      dispatch(setGeneralProgressHide());
      return rejectWithValue(error)
    }
  }
);

const reportsSettingsSlice = createSlice({
  name: 'reportsSettings',
  initialState,
  reducers: {
    clearAgentStatReportState: (state) => {
      state.agentStatReport.error = null;
      state.agentStatReport.isFetching = false;
      state.agentStatReport.data = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAgentStatReportSettingsData.pending, (state ) => {
      state.agentStatReport.isFetching = true;
      state.agentStatReport.error = null;
    });
    builder.addCase(getAgentStatReportSettingsData.fulfilled, (state , action) => {
      state.agentStatReport.error = null;
      state.agentStatReport.isFetching = false;
      state.agentStatReport.data = action.payload;
    });
    builder.addCase(getAgentStatReportSettingsData.rejected, (state , action) => {
      state.agentStatReport.isFetching = false;
      state.agentStatReport.error = action.payload;
      state.agentStatReport.data = null;
    });

  }
});

export const { clearAgentStatReportState } = reportsSettingsSlice.actions;
export default reportsSettingsSlice.reducer;
